import React from "react";

const Page404 = () => {
    return <h1>404</h1>;
};

export default Page404;
